import { useState } from "react";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import styles from "./PasswordField.module.css";

export default function PasswordField({
  id,
  label,
  placeholder,
  value,
  onChange,
  hint,
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <div className={styles.wrap}>
        <input
          id={id}
          className={styles.input}
          type={visible ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        <button
          type="button"
          className={styles.eyeBtn}
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide password" : "Show password"}
        >
          {visible ? <IconEyeOff size={17} /> : <IconEye size={17} />}
        </button>
      </div>
      {hint}
    </div>
  );
}
